// route access handlers expect user object as: {id: int, roles: []string}

function adminRouteAccessHandler(user) {
  let roles = user.roles || [];
  return roles.indexOf('admin') >= 0;
}

function authenticatedRouteAccessHandler(user) {
  return user.id !== "";
}

function anonymousRouteAccessHandler(user) {
  return user.id === "";
}

function extensionChecker(extension) {
  return function(user) {
    return user.epp_extensions.indexOf(extension) > -1;
  }
}

function serviceChecker(service) {
  return function(user) {
    return user.epp_services.indexOf(service) > -1;
  }
}

function chainedHandler() {
  let handlers = arguments;
  return function() {
    for (let i in handlers) {
      if (handlers[i].apply(null, arguments) === false) {
        return false
      }
    }
    return true;
  }
}

export default {
  admin: adminRouteAccessHandler,
  authenticated: authenticatedRouteAccessHandler,
  anonymous: anonymousRouteAccessHandler,
  service: serviceChecker,
  extension: extensionChecker,
  chain: chainedHandler,
}



// WEBPACK FOOTER //
// ./src/routes/access/index.js